import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ac3fd6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "package-product-info-list" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "delete-wrap" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "text xag-ellipsis" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-right" }, null, -1))
const _hoisted_7 = { class: "main-info" }
const _hoisted_8 = { class: "count-wrap" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "购机数量", -1))
const _hoisted_10 = { class: "xag-ellipsis-2" }
const _hoisted_11 = { class: "mathine-bind-list" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-right" }, null, -1))
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "label" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 1,
  class: "warning-tips"
}

import { withDefaults } from 'vue'
import { ApplyFormPackageSelectionsItem } from '@/types/agricultura-loan'
import IconCircleSubtraction from '@/components/icon/IconCircleSubtraction.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'package-product-info',
  props: {
    list: { default: () => [] }
  },
  emits: ['remove', 'selectBindDevice', 'edit'],
  setup(__props: any, { emit: emits }) {

const props = __props as { list: Array<
      ApplyFormPackageSelectionsItem & {
        showWarning?: boolean
      }
    > };





function getWarningMessage(item: ApplyFormPackageSelectionsItem) {
  if (item.num > item.sns.length) {
    return '请选择绑定合约机'
  } else if (item.num < item.sns.length) {
    return '当前绑定的和预计多于购买数量，请删除部分'
  }
}

function removeItem(item: ApplyFormPackageSelectionsItem) {
  emits('remove', item)
}

function selectBindDevice(item: ApplyFormPackageSelectionsItem) {
  emits('selectBindDevice', item)
}
// 单个编辑套餐数据
function changePackageItem(item: ApplyFormPackageSelectionsItem) {
  emits('edit', item)
}
function removeDeviceHandle(item: ApplyFormPackageSelectionsItem, sn: string) {
  item.sns = item.sns.filter((item) => item.serial_number !== sn)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.list, (item, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: item.uuid,
        class: "van-hairline--bottom"
      }, [
        _createElementVNode("div", {
          class: "title-item",
          onClick: ($event: any) => (changePackageItem(item))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "click-cover",
              onClick: _withModifiers(($event: any) => (removeItem(item)), ["stop"])
            }, null, 8, _hoisted_4),
            _createVNode(IconCircleSubtraction)
          ]),
          _createElementVNode("div", _hoisted_5, _toDisplayString(item.productName), 1),
          _hoisted_6
        ], 8, _hoisted_2),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", null, "x" + _toDisplayString(item.num), 1)
          ]),
          _createElementVNode("div", _hoisted_10, _toDisplayString(item.deviceText), 1),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", {
              class: "select-wrap",
              onClick: ($event: any) => (selectBindDevice(item))
            }, [
              _createElementVNode("div", null, "选择合约机 (" + _toDisplayString(item.sns.length) + "/" + _toDisplayString(item.num) + ")", 1),
              _hoisted_13
            ], 8, _hoisted_12),
            (item.sns && item.sns.length)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.sns, (snItem, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: index + snItem.serial_number
                    }, [
                      _createElementVNode("div", _hoisted_15, "设备编码：" + _toDisplayString(snItem.serial_number), 1),
                      _createElementVNode("i", {
                        class: "icon",
                        onClick: ($event: any) => (removeDeviceHandle(item, snItem.serial_number))
                      }, null, 8, _hoisted_16)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (item.showWarning)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(getWarningMessage(item)), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    }), 128))
  ]))
}
}

})